import { WsTypography } from 'wisestep-base';

import WsAccordion from '../../../components/filters/components/WsAccordion';

interface WorkspaceProps {
  title: string;
  text: string;
  optionalText?: string;
}

const FAQDetailsCommonFields = ({ title, text, optionalText }: WorkspaceProps) => (
  <WsAccordion title={title}>
    <WsTypography>{text}</WsTypography>
    <WsTypography>{optionalText ?? ''}</WsTypography>
  </WsAccordion>
);

export default FAQDetailsCommonFields;
